import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const ContentWithButtons = ({
  className,
  title,
  introText,
  bannerText,
  closingText,
  buttons = [],
}) => {
  return (
    <section className={cn(styles.ContentWithButtons, className)}>
      <Container>
        {title && (
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
            data-sourceflow-prop="title"
          />
        )}

        {introText && (
          <div
            className={styles.desc}
            dangerouslySetInnerHTML={{ __html: introText }}
            data-sourceflow-prop="introText"
          />
        )}

        {bannerText && (
          <div
            className={styles.banner}
            dangerouslySetInnerHTML={{ __html: bannerText }}
            data-sourceflow-prop="bannerText"
          />
        )}

        {closingText && (
          <div
            className={styles.desc}
            dangerouslySetInnerHTML={{ __html: closingText }}
            data-sourceflow-prop="closingText"
          />
        )}

        {buttons.length > 0 && (
          <div className={styles.buttonGroup}>
            {buttons.map((btn, idx) => (
              <a key={idx} href={btn.link || "#"} className={styles.buttonLink}>
                <div className={styles.button}>{btn.label}</div>
              </a>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
};


export default ContentWithButtons;